export const LOGIN = "/login";
